import React from 'react';

const TableLedger = ({ ledgerdata, openedit, toggleactive }: any) => {
  const rows = [];
  for (let i = 0; i < ledgerdata.length; i++) {
    const ledger = ledgerdata[i];
    rows.push(
      <tr key={ledger._id} className={ledger.active ? "" : "row-inactive"}>
        <td>
          <select
            className="action-select"
            value=""
            onChange={(e) => {
              if (e.target.value == "Edit") openedit(ledger);
              if (e.target.value == "Toggle") toggleactive(ledger);
            }}
          >
            <option value="">Select…</option>
            <option value="Edit">Edit</option>
            <option value="Toggle">{ledger.active ? "Deactivate" : "Activate"}</option>
          </select>
        </td>
        <td>{ledger.ledgername}</td>
        <td>{ledger.tallygroup}</td>
        <td>{ledger.active ? "Yes" : "No"}</td>
      </tr>
    );
  }

  return (
    <table className="grid">
      <thead>
        <tr>
          <th>action</th>
          <th>ledger name</th>
          <th>Tally group</th>
          <th>active</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default TableLedger;
